<template>
  <vx-card no-shadow>
    <form enctype="multipart/form-data">
      <div class="flex flex-wrap items-center mb-base">
        <vs-avatar :src="computedImageSrc" size="170px" class="mr-4 mb-4" />
        <div>
          <input type="file" id="updateImgInput" class="hidden" ref="updateImgInput" @change="updateCurrImg"
            accept="image/*" />
          <vs-button class="mr-4 sm:mb-0 mb-2" type="flat" @click="$refs.updateImgInput.click()">Upload photo
          </vs-button>
          <!-- <vs-button type="flat" color="#999" @click="image = null">Remove</vs-button> -->
          <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p>
        </div>
      </div>
    </form>
    <!-- Bio -->
    <vs-input class="w-full mt-8" type="text" label-placeholder="Organisation Name" v-model="organistion" />
    <vs-input class="w-full mt-8" type="text" label-placeholder="Address" v-model="address" />
    <!-- Country -->
    <div class="mt-8">
      <label class="text-sm">Country</label>
      <v-select v-model="country" :options="countryOptions" @input="State()" label="country_name"
        :dir="$vs.rtl ? 'rtl' : 'ltr'" />
    </div>
    <div class="mt-8">
      <label class="text-sm">Region</label>
      <v-select v-model="region" :options="countryStates" label="state_name" />
    </div>
    <vs-input class="w-full mt-8" type="text" label-placeholder="City" v-model="city" />

    <vs-input class="w-full mt-8" type="number" label-placeholder="Postal Code" v-model="postal" />
    <vs-input class="w-full mt-8" type="text" label-placeholder="Usdot" v-model="USDOT" />
    <!-- Languages -->
    <!-- <div class="mt-8">
      <label class="text-sm">Languages</label>
      <v-select v-model="lang_known" multiple :closeOnSelect="false" :options="langOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
    </div> -->

    <!-- Mobile Number -->
    <vs-input class="w-full mt-8" type="text" label-placeholder="Contact Person" v-model="cperson" />
    <vs-input class="w-full mt-8" type="text" label-placeholder="Phone number" v-model="mobile" />
    <vs-input class="w-full mt-8" type="email" label-placeholder="Email" v-model="email" />
    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" v-on:click="submitData()">Save Changes</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
    </div>
  </vx-card>
</template>
<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import axios from "axios";
import userAvatar from "@/assets/images/pages/userAvatar.png";

export default {
  components: {
    flatPickr,
    vSelect,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_MEDIA,
      img: null,
      image: null,
      password: "",
      first_name: "",
      last_name: "",
      USDOT: null,
      time_zone: "",
      data: "",
      organistion: "",
      countryStates: [],
      address: "",
      postal: "",
      cperson: "",
      city: "",
      mobile: "",
      email: "",
      region: "",
      country: "",
      to_useToken: null,

      // Options
      countryOptions: [
        { label: "Australia", value: "australia" },
        { label: "France", value: "france" },
        { label: "Germany", value: "germany" },
        { label: "India", value: "india" },
        { label: "Jordan", value: "jordan" },
        { label: "Morocco", value: "morocco" },
        { label: "Portuguese", value: "portuguese" },
        { label: "Syria", value: "syria" },
        { label: "USA", value: "usa" },
      ],
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    computedImageSrc() {
      return this.$store.state.company.image
        ? this.baseUrl + this.$store.state.company.image.slice(1)
        : userAvatar;
    },
    imageP() {
      return this.$store.state.company.image;
    },
  },
  methods: {
    updateCurrImg(input) {
      // console.log(input.target.files);
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.image = e.target.result;
        };
        this.img = this.$refs.updateImgInput.files[0];
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    submitData() {
      // console.log(this.country);
      this.$vs.loading();
      let formData = new FormData();
      formData.append("image", this.img);
      const obj = {
        formData,
        image: this.image,
        company_name: this.organistion,
        address: this.address,
        postal_code: this.postal,
        contact_person: this.cperson,
        city: this.city,
        region: this.region.state_name,
        phone: this.mobile,
        email: this.email,
        country: this.country.country_name,
        first_name: this.first_name,
        last_name: this.last_name,
        usdot: this.USDOT,
        time_zone: this.time_zone,
        password: this.password,
      };
      this.$store
        .dispatch("company/addItem", obj)
        .then(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: "Edited",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
      if (this.image !== null) {
        this.$store.dispatch("company/addImg", obj.formData);
      }
    },

    fetchList() {
      this.$store.dispatch("company/fetchImgListItems");
      this.$store.dispatch("company/fetchDataListItems").then((response) => {
        this.password = response.data.password;
        (this.organistion = response.data.company_name),
          (this.address = response.data.address),
          (this.postal = response.data.postal_code),
          (this.cperson = response.data.contact_person),
          (this.city = response.data.city),
          (this.region = response.data.region),
          (this.mobile = response.data.phone),
          (this.email = response.data.email),
          (this.country = response.data.country),
          (this.first_name = response.data.first_name),
          (this.last_name = response.data.last_name),
          (this.USDOT = response.data.usdot),
          (this.time_zone = response.data.time_zone);
      });
    },
    a() {
      axios
        .get("https://www.universal-tutorial.com/api/getaccesstoken", {
          headers: {
            Accept: "application/json",
            "api-token":
              "ZFhSles_9Z17tX0OMLFQDYwHagiTbZUc0oLtE62xUomy8LQDpZbg5QsGTJesW5gmozo",
            "user-email": "axunovnusrat5@gmail.com",
          },
        })
        .then((res) => {
          this.to_useToken = res.data.auth_token;
          axios
            .get("https://www.universal-tutorial.com/api/countries/", {
              headers: {
                Authorization: `Bearer ${res.data.auth_token}`,
                Accept: "application/json",
              },
            })
            .then((res) => {
              this.countryOptions = res.data;
              // console.log(this.countryOptions);
            })
            .catch();
          axios
            .get(
              `https://www.universal-tutorial.com/api/states/${this.country}`,
              {
                headers: {
                  Authorization: `Bearer ${this.to_useToken}`,
                  Accept: "application/json",
                },
              }
            )
            .then((res) => {
              this.countryStates = res.data;
            })
            .catch();
        });
    },
    State() {
      axios
        .get(
          `https://www.universal-tutorial.com/api/states/${this.country.country_name}`,
          {
            headers: {
              Authorization: `Bearer ${this.to_useToken}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          this.countryStates = res.data;
        })
        .catch();
    },
  },
  mounted() {
    this.fetchList();
    this.a();
    // this.updateCurrImg()
    // console.log(this.updateCurrImg())
  },
};
</script>
